import {
    PAYMENTBRANDLIST_SUCCESS,
    PAYMENTBRANDLIST_FAILED,
    RESET_PAYMENTBRANDLIST,
    LOADING_PAYMENTBRANDLIST,
    NETWORK_ERROR_PAYMENTBRANDLIST,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetGetPaymentBrandList = () => {
    return { type: RESET_PAYMENTBRANDLIST };
};

const getPaymentBrandList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_PAYMENTBRANDLIST });
    await adminServices
        .post("getPaymentBrandList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getPaymentBrandListsuccess(res.data));
                    break;
                default:
                    dispatch(getPaymentBrandListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_PAYMENTBRANDLIST, payload: err });
        });
};
function getPaymentBrandListsuccess(data) {
    return {
        type: PAYMENTBRANDLIST_SUCCESS,
        payload: data,
    };
}
function getPaymentBrandListFailed(data) {
    return {
        type: PAYMENTBRANDLIST_FAILED,
        payload: data,
    };
}

export { resetGetPaymentBrandList, getPaymentBrandList };
